import { loadMoreResults } from '../../search/load_more_results.js';

window.ProjectUpdates = {
  initializeDashboardList(indexParams) {
    this._projectSearch = SearchUtils.createInstantSearch(indexParams.appId, indexParams.key, indexParams.name);

    this._projectSearch.addWidgets([
      instantsearch.widgets.configure({
        hitsPerPage: 48,
        filters: this._getQuery()
      }),
      this._quickListWidget(),
      this._projectsListInfiniteHitsWidget()
    ]);
    this._projectSearch.start();
    loadMoreResults();

    return this._projectSearch.on('render', () => $.cloudinary.responsive());
  },

  _getQuery() {
    if ($('#recent').val() === 'tracked') {
      return `follower_ids=${userId} OR tagger_ids=${userId}`;
    } else {
      return '';
    }
  },

  _quickListWidget() {
    return {
      init(options) {
        return $(document).on('click', '#dashboard-view-mode > li', function () {
          document.getElementById('rolldown-title').innerText = $(event.target).text();
          $('#recent').val(event.target.attributes.value.value);
          return options.helper.setQuery('').search();
        });
      },
      render() { }
    };
  },

  _projectsListInfiniteHitsWidget() {
    return instantsearch.widgets.infiniteHits({
      container: '#dashboard-projects-grid',
      templates: {
        item: $('#project-template').text(),
        empty: $('#no-projects-found-template').text()
      },
      cssClasses: {
        root: 'ais-Hits',
        list: 'ais-Hits-list list-view grid items borders',
        item: 'item'
      },
      transformItems: items => {
        items.length == 0 ? $('#search-nav-bar .section-header').hide().hide() : $('#search-nav-bar .section-header').hide().show();
        items.map(item => {
          if (item.tagger_ids.indexOf(userId) >= 0) {
            item.tagged = true;
          }
          if (item.follower_ids.indexOf(userId) >= 0) {
            item.liked = true;
          }
          const status = PublicIndexesProjectsWidgets._projectStatus(userMembership, trial, item);
          item.status = status[0];
          item.status_text = status[1];
          return item;
        });
        return items;
      }
    });
  }
};
